import { render, staticRenderFns } from "./TemplatesmsHome.vue?vue&type=template&id=6a63d8a0"
import script from "./TemplatesmsHome.vue?vue&type=script&lang=js"
export * from "./TemplatesmsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports